import * as types from './types'
import { PlanimetryProxy } from '~/services'
import { mockPagedList } from '~/views/shared'
import { SeatStatus, IDENTIFICATION_TYPES } from 'config/constants'

export const pagedLayoutsAttempt = (reqParams) => ({
  type: types.PAGED_LAYOUTS_ATTEMPT,
  reqParams
})

export const pagedLayoutsSuccess = (pagedLayouts) => ({
  type: types.PAGED_LAYOUTS_SUCCESS,
  pagedLayouts
})

export const pagedLayoutsFailure = (error) => ({
  type: types.PAGED_LAYOUTS_FAILURE,
  error
})

export const loadLayoutOptionsAttempt = () => ({
  type: types.LOAD_LAYOUT_OPTIONS_ATTEMPT
})

export const loadLayoutOptionsSuccess = (layoutOptions) => ({
  type: types.LOAD_LAYOUT_OPTIONS_SUCCESS,
  layoutOptions
})

export const loadLayoutOptionsFailure = (error) => ({
  type: types.LOAD_LAYOUT_OPTIONS_FAILURE,
  error
})

export const pagedSectorsAttempt = (reqParams) => ({
  type: types.PAGED_SECTORS_ATTEMPT,
  reqParams
})

export const pagedSectorsSuccess = (pagedSectors) => ({
  type: types.PAGED_SECTORS_SUCCESS,
  pagedSectors
})

export const pagedSectorsFailure = (error) => ({
  type: types.PAGED_SECTORS_FAILURE,
  error
})

export const loadSectorsAttempt = () => ({
  type: types.LOAD_SECTORS_ATTEMPT
})

export const loadSectorsSuccess = (sectors) => ({
  type: types.LOAD_SECTORS_SUCCESS,
  sectors
})

export const loadSectorsFailure = (error) => ({
  type: types.LOAD_SECTORS_FAILURE,
  error
})

export const loadSeatsInfoSellAttempt = () => ({
  type: types.LOAD_SEATS_INFO_SELL_ATTEMPT
})

export const loadSeatsInfoSellSuccess = (seatsInfo) => ({
  type: types.LOAD_SEATS_INFO_SELL_SUCCESS,
  seatsInfo
})

export const loadSeatsInfoSellFailure = (error) => ({
  type: types.LOAD_SEATS_INFO_SELL_FAILURE,
  error
})

export const loadSeatsAttempt = () => ({
  type: types.LOAD_SEATS_ATTEMPT
})

export const loadSeatsSuccess = (seats) => ({
  type: types.LOAD_SEATS_SUCCESS,
  seats
})

export const loadSeatsFailure = (error) => ({
  type: types.LOAD_SEATS_FAILURE,
  error
})

export const loadLayoutAttempt = () => ({
  type: types.LOAD_LAYOUT_ATTEMPT
})

export const loadLayoutSuccess = (layout) => ({
  type: types.LOAD_LAYOUT_SUCCESS,
  layout
})

export const loadLayoutFailure = (error) => ({
  type: types.LOAD_LAYOUT_FAILURE,
  error
})

export const loadSectorAttempt = () => ({
  type: types.LOAD_SECTOR_ATTEMPT
})

export const loadSectorSuccess = (sector) => ({
  type: types.LOAD_SECTOR_SUCCESS,
  sector
})
export const loadSectorFailure = (error) => ({
  type: types.LOAD_SECTOR_FAILURE,
  error
})

export const createLayoutAttempt = () => ({
  type: types.CREATE_LAYOUT_ATTEMPT
})

export const createLayoutSuccess = (layout) => ({
  type: types.CREATE_LAYOUT_SUCCESS,
  layout
})

export const createLayoutFailure = (error) => ({
  type: types.CREATE_LAYOUT_FAILURE,
  error
})

export const updateLayoutAttempt = () => ({
  type: types.UPDATE_LAYOUT_ATTEMPT
})

export const updateLayoutSuccess = (layout) => ({
  type: types.UPDATE_LAYOUT_SUCCESS,
  layout
})

export const updateLayoutFailure = (error) => ({
  type: types.UPDATE_LAYOUT_FAILURE,
  error
})

export const createSectorAttempt = () => ({
  type: types.CREATE_SECTOR_ATTEMPT
})

export const createSectorSuccess = (sector) => ({
  type: types.CREATE_SECTOR_SUCCESS,
  sector
})

export const createSectorFailure = (error) => ({
  type: types.CREATE_SECTOR_FAILURE,
  error
})

export const updateSectorAttempt = () => ({
  type: types.UPDATE_SECTOR_ATTEMPT
})

export const updateSectorSuccess = (sector) => ({
  type: types.UPDATE_SECTOR_SUCCESS,
  sector
})

export const updateSectorFailure = (error) => ({
  type: types.UPDATE_SECTOR_FAILURE,
  error
})

export const createSeatsAttempt = () => ({
  type: types.CREATE_SEATS_ATTEMPT
})

export const createSeatsSuccess = (seats) => ({
  type: types.CREATE_SEATS_SUCCESS,
  seats
})

export const createSeatsFailure = (error) => ({
  type: types.CREATE_SEATS_FAILURE,
  error
})

export const updateSeatsAttempt = () => ({
  type: types.UPDATE_SEATS_ATTEMPT
})

export const updateSeatsSuccess = (seats) => ({
  type: types.UPDATE_SEATS_SUCCESS,
  seats
})

export const updateSeatsFailure = (error) => ({
  type: types.UPDATE_SEATS_FAILURE,
  error
})

export const deleteSectorAttempt = () => ({
  type: types.DELETE_SECTOR_ATTEMPT
})

export const deleteSectorSuccess = (sector) => ({
  type: types.DELETE_SECTOR_SUCCESS,
  sector
})

export const deleteSectorFailure = (error) => ({
  type: types.DELETE_SECTOR_FAILURE,
  error
})

export const deleteLayoutAttempt = () => ({
  type: types.DELETE_LAYOUT_ATTEMPT
})

export const deleteLayoutSuccess = (layout) => ({
  type: types.DELETE_LAYOUT_SUCCESS,
  layout
})

export const deleteLayoutFailure = (error) => ({
  type: types.DELETE_LAYOUT_FAILURE,
  error
})

export const assignLayoutAttempt = () => ({
  type: types.ASSIGN_LAYOUT_ATTEMPT
})

export const assignLayoutSuccess = (layout) => ({
  type: types.ASSIGN_LAYOUT_SUCCESS,
  layout
})

export const assignLayoutFailure = (error) => ({
  type: types.ASSIGN_LAYOUT_FAILURE,
  error
})

export const loadAssignableTicketsAttempt = () => ({
  type: types.LOAD_ASSIGNABLE_TICKETS_ATTEMPT
})

export const loadAssignableTicketsSuccess = (tickets) => ({
  type: types.LOAD_ASSIGNABLE_TICKETS_SUCCESS,
  tickets
})

export const loadAssignableTicketsFailure = (error) => ({
  type: types.LOAD_ASSIGNABLE_TICKETS_FAILURE,
  error
})

export const assignTicketToSectorAttempt = () => ({
  type: types.ASSIGN_TICKET_TO_SECTOR_ATTEMPT
})

export const assignTicketToSectorSuccess = (assignedTicket) => ({
  type: types.ASSIGN_TICKET_TO_SECTOR_SUCCESS,
  assignedTicket
})

export const assignTicketToSectorFailure = (error) => ({
  type: types.ASSIGN_TICKET_TO_SECTOR_FAILURE,
  error
})

export const reset = () => ({
  type: types.RESET
})

export const resetActions = () => ({
  type: types.RESET_ACTIONS
})

export const resetParamsLocations = () => ({
  type: types.RESET_PARAMS
})

export const loadLayouts =
  (locationId, { searchParams, pageNumber, pageSize, orderBy, order }) =>
  async (dispatch) => {
    try {
      dispatch(pagedLayoutsAttempt({ searchParams, order, orderBy }))

      const proxy = new PlanimetryProxy()
      const response = await proxy.getLayouts(locationId)

      dispatch(
        pagedLayoutsSuccess(
          mockPagedList(response, pageSize, pageNumber, order, orderBy)
        )
      )
    } catch (e) {
      dispatch(pagedLayoutsFailure(e))
      throw e
    }
  }

export const loadLayoutOptions = (locationId) => async (dispatch) => {
  try {
    dispatch(loadLayoutOptionsAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getLayoutOptions(locationId)

    dispatch(loadLayoutOptionsSuccess(response))
    return response
  } catch (e) {
    dispatch(loadLayoutOptionsFailure(e))
    throw e
  }
}

export const loadSectorsPaged =
  (layoutId, { searchParams, pageNumber, pageSize, orderBy, order }) =>
  async (dispatch) => {
    try {
      dispatch(pagedSectorsAttempt({ searchParams, order, orderBy }))

      const proxy = new PlanimetryProxy()
      const response = await proxy.getSectors(layoutId)

      const sectorsWithSeats = await Promise.all(
        response.map(async (sector) => {
          const seatsResponse = await proxy.getSeats(sector.Id)
          const seats = seatsResponse?.SeatDistribution || []
          let availables = 0,
            solds = 0,
            emptys = 0

          seats.forEach((seat) => {
            if (!seat.IsSeat) return
            if (seat.Status === SeatStatus.Available) availables++
            if (seat.Status === SeatStatus.Sold) solds++
            if (seat.Status === SeatStatus.Empty) emptys++
          })

          return { ...sector, availables, solds, emptys }
        })
      )

      // No necesitamos otro sort aquí: mockPagedList ya lo hace.
      dispatch(
        pagedSectorsSuccess(
          mockPagedList(sectorsWithSeats, pageSize, pageNumber, order, orderBy)
        )
      )
    } catch (e) {
      dispatch(pagedSectorsFailure(e))
      throw e
    }
  }

export const loadSectors = (layoutId) => async (dispatch) => {
  try {
    dispatch(loadSectorsAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getSectors(layoutId)

    const sectorsWithSeats = await Promise.all(
      response.map(async (sector) => {
        const seatsResponse = await proxy.getSeats(sector.Id)
        const seats = seatsResponse?.SeatDistribution || []
        let availables = 0
        let solds = 0
        seats.forEach((seat) => {
          if (seat.IsSeat) {
            if (seat.Status === SeatStatus.Available) availables++
            if (seat.Status === SeatStatus.Sold) solds++
          }
        })
        return {
          ...sector,
          availables,
          solds
        }
      })
    )

    dispatch(loadSectorsSuccess(sectorsWithSeats))
    return sectorsWithSeats
  } catch (e) {
    dispatch(loadSectorsFailure(e))
    throw e
  }
}

export const loadSeats = (sectorId) => async (dispatch) => {
  try {
    dispatch(loadSeatsAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getSeats(sectorId)

    const seats = response?.SeatDistribution.filter((seat) => seat.IsSeat).map(
      (seat) => ({
        id: seat.Id,
        row: seat.Row,
        column: seat.Column,
        status: seat.Status,
        ticketId: seat.CurrentTicketTypeId
      })
    )
    dispatch(loadSeatsSuccess(seats))
    return seats
  } catch (e) {
    dispatch(loadSeatsFailure(e))
    throw e
  }
}

export const loadSeatsInfoSell = (sectorId) => async (dispatch) => {
  try {
    dispatch(loadSeatsInfoSellAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getSeatsInfoSell(sectorId)

    const seatsInfo = response?.SeatDistribution.filter(
      (seat) => seat.IsSeat
    ).map((seat) => ({
      id: seat.Id,
      row: seat.Row,
      column: seat.Column,
      status: seat.Status,
      ticketId: seat.CurrentTicketTypeId,
      userId: seat.UserId,
      documentType: IDENTIFICATION_TYPES[seat?.IdentificationType],
      documentNumber: seat.IdentificationNumber,
      fullName: seat.FullName,
      description: seat.Description
    }))
    dispatch(loadSeatsInfoSellSuccess(seatsInfo))
    return seatsInfo
  } catch (e) {
    dispatch(loadSeatsInfoSellFailure(e))
    throw e
  }
}

export const loadLayout = (layoutId) => async (dispatch) => {
  try {
    dispatch(loadLayoutAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getLayoutById(layoutId)

    dispatch(loadLayoutSuccess(response))
  } catch (e) {
    dispatch(loadLayoutFailure(e))
    throw e
  }
}

export const loadSector = (sectorId) => async (dispatch) => {
  try {
    dispatch(loadSectorAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.getSectorById(sectorId)

    dispatch(loadSectorSuccess(response))
    return response
  } catch (e) {
    dispatch(loadSectorFailure(e))
    throw e
  }
}

export const createLayout =
  ({ ImageFile, LayoutName, LocationId }) =>
  async (dispatch) => {
    try {
      dispatch(createLayoutAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.postLayout(ImageFile, LayoutName, LocationId)

      dispatch(createLayoutSuccess(response))
    } catch (error) {
      dispatch(createLayoutFailure(error))
      throw error
    }
  }

export const updateLayout =
  ({ LayoutId, ImageFile, LayoutName, LocationId }) =>
  async (dispatch) => {
    try {
      dispatch(updateLayoutAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.putLayout(
        LayoutId,
        ImageFile,
        LayoutName,
        LocationId
      )

      dispatch(updateLayoutSuccess(response))
    } catch (error) {
      dispatch(updateLayoutFailure(error))
      throw error
    }
  }

export const createSector =
  ({
    ImageId,
    ImageFile,
    SectorName,
    LayoutId,
    Row,
    RowDescriptor,
    Column,
    ColumnDescriptor,
    Color
  }) =>
  async (dispatch) => {
    try {
      dispatch(createSectorAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.postSector(
        ImageId,
        ImageFile,
        SectorName,
        LayoutId,
        Row,
        RowDescriptor,
        Column,
        ColumnDescriptor,
        Color
      )

      dispatch(createSectorSuccess(response))
      return response
    } catch (error) {
      dispatch(createSectorFailure(error))
      throw error
    }
  }

export const updateSector =
  ({
    SectorId,
    ImageId,
    ImageFile,
    SectorName,
    LayoutId,
    Row,
    RowDescriptor,
    Column,
    ColumnDescriptor,
    Color
  }) =>
  async (dispatch) => {
    try {
      dispatch(updateSectorAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.putSector(
        SectorId,
        ImageId,
        ImageFile,
        SectorName,
        LayoutId,
        Row,
        RowDescriptor,
        Column,
        ColumnDescriptor,
        Color
      )

      dispatch(updateSectorSuccess(response))
    } catch (error) {
      dispatch(updateSectorFailure(error))
      throw error
    }
  }

export const createSeats = (payload) => async (dispatch) => {
  try {
    dispatch(createSeatsAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.postSeats(payload)

    dispatch(createSeatsSuccess(response))
  } catch (error) {
    dispatch(createSeatsFailure(error))
    throw error
  }
}

export const updateSeats = (payload) => async (dispatch) => {
  try {
    dispatch(updateSeatsAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.putSeats(payload)

    dispatch(updateSeatsSuccess(response))
  } catch (error) {
    dispatch(updateSeatsFailure(error))
    throw error
  }
}

export const deleteLayout = (sectorId) => async (dispatch) => {
  try {
    dispatch(deleteLayoutAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.deleteLayout(sectorId)

    dispatch(deleteLayoutSuccess(response))
  } catch (e) {
    dispatch(deleteLayoutFailure(e))
    throw e
  }
}

export const deleteSector = (sectorId) => async (dispatch) => {
  try {
    dispatch(deleteSectorAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.deleteSector(sectorId)

    dispatch(deleteSectorSuccess(response))
  } catch (e) {
    dispatch(deleteSectorFailure(e))
    throw e
  }
}

export const assignLayoutToEvent = (LayoutId, EventId) => async (dispatch) => {
  try {
    dispatch(assignLayoutAttempt())

    const proxy = new PlanimetryProxy()
    const response = await proxy.assignLayoutToEvent(LayoutId, EventId)

    dispatch(assignLayoutSuccess(response))
    return response
  } catch (e) {
    dispatch(assignLayoutFailure(e))
    throw e
  }
}

export const loadAssignableTickets =
  (layoutId, sectorId, eventId) => async (dispatch) => {
    try {
      dispatch(loadAssignableTicketsAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.getAssignableTickets(
        layoutId,
        sectorId,
        eventId
      )

      dispatch(loadAssignableTicketsSuccess(response))
      return response
    } catch (e) {
      dispatch(loadAssignableTicketsFailure(e))
      throw e
    }
  }

export const assignTicketToSector =
  (layoutId, sectorId, ticketTypeId) => async (dispatch) => {
    try {
      dispatch(assignTicketToSectorAttempt())

      const proxy = new PlanimetryProxy()
      const response = await proxy.assignTicketToSector(
        layoutId,
        sectorId,
        ticketTypeId
      )

      dispatch(assignTicketToSectorSuccess(response))
      return response
    } catch (e) {
      dispatch(assignTicketToSectorFailure(e))
      throw e
    }
  }
